export const modalHeaderPassthrough = {
  root: {
    class: "w-3/5",
  },
  header: {
    class: [
      "bg-emerald-50",
      "min-h-65",
      "flex",
      "justify-between",
      "items-center",
      "pl-5",
      "pr-2",
      "rounded-t-lg",
      "border",
      "border-white",
    ],
  },
};
